<template>
    <!-- 对账记录 -->
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="submitForm">
				<el-form-item label="当前页数：">
				    <el-input
						style="width:108px;"
				        size
				        clearable
				        v-model="submitForm.page"
				        placeholder="请输入页数"
				    ></el-input>
				</el-form-item>
				<el-form-item>
				    <el-input
				        size
				        clearable
				        v-model="submitForm.memberNo"
				        placeholder="商户编号"
				    ></el-input>
				</el-form-item>
				<el-form-item>
				    <el-select size v-model="submitForm.recordType" clearable placeholder="请选择审核状态">
				        <el-option label="创建账户" value="CREATE_AMOUNT"></el-option>
				      <!--  <el-option label="返现入账" value="CASHBACK_CREDIT"></el-option>
				        <el-option label="返现出账" value="CASHBACK_DEBIT"></el-option>
				        <el-option label="消费" value="CONSUME"></el-option>
				        <el-option label="补贴" value="SUBSIDY"></el-option>
				        <el-option label="消费撤销" value="CONSUMECANCEL"></el-option>
				        <el-option label="退货" value="REFUND"></el-option>
				        <el-option label="T0结算出" value="T0_SETTLE_DEBIT"></el-option>
				        <el-option label="T1结算出" value="T1_SETTLE_DEBIT"></el-option> 
				        <el-option label="冲正" value="REVERSAL"></el-option> -->
				        <el-option label="调账" value="ADJUST"></el-option>
				        <!-- <el-option label="返点" value="REBATES"></el-option> -->
				        <el-option label="日结分润出账" value="D_PROFIT_DEBIT"></el-option>
				        <el-option label="日结分润入账" value="D_PROFIT_CREDIT"></el-option>
				        <el-option label="充值" value="RECHARGE"></el-option>
				        <el-option label="货款" value="PAYMENTGOODS"></el-option>
				        <el-option label="退回账户" value="BACK_ACCOUNT"></el-option>
				        <el-option label="服务费" value="SERVICEFEE"></el-option>
				    </el-select>
				</el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
				<el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(submitForm)"
                    >查询</el-button>
                </el-form-item>
				<el-form-item>
				  <el-button
				      size="small"
				      type="primary"
				      icon="el-icon-download"
				      :loading="downLoading"
				      @click="handleDownLoad(submitForm)"
				  >导出数据</el-button>
				</el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="centerList" size="mini" border style="width: 100%" v-loading="loading">
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="flowNo"
                    width="300"
                    label="流水号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="accountNo"
                    label="账户号"
					width="150"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="direction"
				    label="资金方向"
				    width="120"
					:formatter="formatdirection"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="amount"
				    label="交易发生金额"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="requestType"
				    label="请求类型"
				    width="80"
					:formatter="formatType"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="avaliableBalance"
				    label="当前可用余额"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="afterAvailableBalance"
				    label="发生后可用余额"
				    width="110"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="balance"
				    label="实际余额"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="afterBalance"
				    label="发生后实际余额"
				    width="110"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="frozenQuota"
				    label="冻结金额"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="afterFrozenQuota"
				    label="交易发生后冻结金额"
				    width="130"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="remark"
				    label="备注"
				    width="100"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="createDate"
				    label="创建时间"
				    width="150"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="recordType"
				    label="资金类型"

					:formatter="formatrecordType"
				></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[1000]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <!-- <record-info v-if="info.isShow" :info="info" @infoClose="handleCloseInfo"></record-info> -->
    </div>
</template>

<script>
// import recordInfo from './components/contrastRecordDetail';
export default {
    data() {
        return {
			submitForm: {
			    memberNo: '', //商户号
				createDateBegin: "",
				createDateEnd: "",
				recordType: "",
				page: 1,
				limit: 1000
			},
            rangeDate: [], //时间范围
            centerList: [],
            currentPage: 1, //当前页码
            pageSize: 1000, //条数
            total: 0,  //总数
            loading: false,
			downLoading: false, //导出loading
        }
    },
    components: {

    },
    mounted() {
		this.handleDefaultTime();
        this.getData({
            page: 1,
            limit: 1000
        })
    },
    methods: {
        handleSearch(submitForm) { //搜索
            this.currentPage = 1;
            submitForm.page = 1;
            this.getData(submitForm);
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.submitForm.page = page;
            this.submitForm.limit = this.pageSize;
            this.getData(this.submitForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.submitForm.page = 1;
            this.submitForm.limit = limit;
            this.getData(this.submitForm);
        },
        getData() { //获取数据
            this.$api.post("export/for_ward_list", this.submitForm, res => {
                if (res.code == "00") {
                    // let data = res.data;
                    this.total = res.data.count; //总数
                    this.centerList = res.data.list;
                    // this.centerList = [];
                    //渲染结束后取消加载
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
		handleDownLoad() { //导出
		  this.downLoading = true;
		  this.$api.post("export/for_ward_list_download", this.submitForm, res => {
		    if (res.code == 0) {
		      this.$message.success(res.msg);
		      var link=this.$file_url+res.data;
		      window.open(link)
		    } else {
		      this.$message.error(res.msg);
		    }
		    //渲染结束后取消加载
		    this.downLoading = false;
		  })
		},
		handleDefaultTime() { //默认获取三十天
		    let date =this.$moment().endOf('day').format('x');
		    this.submitForm.createDateEnd = this.$moment(Number(date)).format("YYYY-MM-DD");
		    this.submitForm.createDateBegin = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD");
		    this.rangeDate = [this.submitForm.createDateBegin, this.submitForm.createDateEnd];
		},
        pickerChange(DateArr) { //时间选择器
            this.submitForm.createDateBegin = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.submitForm.createDateEnd = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
		formatdirection(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.direction) {
				case  "UNCHANGE":
					card = '不变';
					break;
				case  "INCREMENT":
					card = '资金变动方向增加';
					break;
				case  "DECREASE":
					card = '资金变动方向减少';
					break;
		        default:
		            card = '初始化（创建）';
		            break;
		    }
		    return card;
		},
		formatType(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.requestType) {
				case  "CREDIT":
					card = '资金入账';
					break;
				case  "DEBIT":
					card = '资金出账';
					break;
				case  "FROZEN":
					card = '资金冻结';
					break;
				case  "UNFROZEN":
					card = '资金解冻，出帐';
					break;
		        default:
		            card = '创建帐户';
		            break;
		    }
		    return card;
		},
		formatrecordType(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.recordType) {
				case  "CASHBACK_CREDIT":
					card = '返现入账';
					break;
				case  "CASHBACK_DEBIT":
					card = '返现出账';
					break;
				case  "CONSUME":
					card = '消费';
					break;
				case  "SUBSIDY":
					card = '补贴';
					break;
				case  "CONSUMECANCEL":
					card = '消费撤销';
					break;
				case  "REFUND":
					card = '退货';
					break;
				case  "T0_SETTLE_DEBIT":
					card = 'T0结算出';
					break;
				case  "T1_SETTLE_DEBIT":
					card = 'T1结算出';
					break;
				case  "REVERSAL":
					card = '冲正';
					break;
				case  "ADJUST":
					card = '调账';
					break;
				case  "REBATES":
					card = '返点';
					break;
				case  "D_PROFIT_DEBIT":
					card = '日结分润出账';
					break;
				case  "D_PROFIT_CREDIT":
					card = '日结分润入账';
					break;
				case  "RECHARGE":
					card = '充值';
					break;
				case  "PAYMENTGOODS":
					card = '货款';
					break;
		        default:
		            card = '创建帐户';
		            break;
		    }
		    return card;
		},
    }
}
</script>

<style scoped lang="scss">
</style>